import React from "react";

const Button = ({
  className = "bg-purple-600 text-white py-2 px-4 rounded-md hover:bg-purple-700 focus:outline-none",
  children,
  btnOnlcick,
  buttonText,
  ...props
}) => {
  return (
    <button onClick={btnOnlcick} className={className}>
      {children}
    </button>
  );
};

export default Button;
